export enum FootballMatchStatusEnum {
  NONE = "none",
  FINISHED = "finished",
  CANCELLED = "cancelled",
  POSTPONED = "postponed",
  NOT_STARTED = "not_started",
  FIRST_HALF = "1st_half",
  SECOND_HALF = "2nd_half",
  FINISHED_AFTER_AWARDED_WIN = "finished_after_awarded_win",
  TO_FINISH = "to_finish",
  FINISHED_AET = "finished_aet",
  HALFTIME = "halftime",
  FINISHED_AP = "finished_ap",
  INTERRUPTED = "interrupted",
  KICK_OFF_DELAYED = "kick_off_delayed",
  ABANDONED = "abandoned",
  WAITING_FOR_PENALTY = "waiting_for_penalty",
  PENALTY = "penalty",
  PAUSE = "pause",
  EXTRA_TIME_1ST_HALF = "extra_time_1st_half",
  EXTRA_TIME_END_OF_1ST_HALF = "extra_time_end_of_1st_half",
  EXTRA_TIME_2ND_HALF = "extra_time_2nd_half",
  WAITING_FOR_EXTRA_TIME = "waiting_for_extra_time",
  NO_INFO_YET = "no_info_yet",
  AWAITING_INFO = "awaiting_info",
  FINISHED_ASG = "finished_asg"
}